import { useEffect } from 'react';
import api from '../../lib/api';
import { getCookieConsent } from './CookieConsent';

/**
 * Loads tenant-configured Google Analytics (GA4) and/or Google Tag Manager
 * scripts at runtime, only when BOTH conditions hold:
 *   1. The admin has enabled analytics, and
 *   2. The visitor has accepted cookies (KVKK consent).
 * Scripts are injected once (guarded by id) so SPA navigation never duplicates
 * them. Re-runs automatically when the visitor accepts cookies.
 */
function injectAnalytics() {
  if (getCookieConsent() !== 'accepted') return;
  api.get('/settings/analytics')
    .then((r) => {
      const d = r.data || {};
      const enabled = d.enabled === true || d.enabled === 'true' || d.enabled === 'True';
      if (!enabled) return;
      const gaId = (d.ga_id || '').trim();
      const gtmId = (d.gtm_id || '').trim();

      if (gaId && !document.getElementById('ga4-src')) {
        const s = document.createElement('script');
        s.id = 'ga4-src';
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(s);
        const inline = document.createElement('script');
        inline.id = 'ga4-init';
        inline.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId}');`;
        document.head.appendChild(inline);
      }

      if (gtmId && !document.getElementById('gtm-src')) {
        const s = document.createElement('script');
        s.id = 'gtm-src';
        s.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;
        document.head.appendChild(s);
      }
    })
    .catch(() => {});
}

export function AnalyticsLoader() {
  useEffect(() => {
    injectAnalytics();
    const onConsent = (e) => {
      if (e.detail === 'accepted') injectAnalytics();
    };
    window.addEventListener('cookie-consent-changed', onConsent);
    return () => window.removeEventListener('cookie-consent-changed', onConsent);
  }, []);
  return null;
}

export default AnalyticsLoader;
